import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TaggedObject } from '@cod-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    private apiUrl = `${environment.apiUrl}/reports`;
    constructor(private httpClient: HttpClient) {}

    public requestReport(email: string): Observable<void> {
        return this.httpClient.post<void>(`${this.apiUrl}/request`, { email });
    }

    public getReports(): Observable<TaggedObject[]> {
        return this.httpClient.get<TaggedObject[]>(`${this.apiUrl}/list`);
    }

    public getReportDownloadLink(reportName: string): Observable<string> {
        return this.httpClient.get<string>(`${this.apiUrl}/${reportName}`, {
            responseType: 'text' as 'json'
        });
    }

    public getLegacyReportDownloadLink(): Observable<string> {
        return this.httpClient.get<string>(`${this.apiUrl}/report/legacy`, {
            responseType: 'text' as 'json'
        });
    }
}
